import {
  FormInputNumeric,
  type FormInputNumericProps,
} from "@/components/form-elements/FormInputNumeric"
import { cn } from "@/lib/utils"

import type { FieldValues } from "react-hook-form"

export const FR_CONTROL_HEIGHT = "h-12"

export function FormMoneyInput<T extends FieldValues = FieldValues>({
  inputClassName,
  ...props
}: FormInputNumericProps<T>) {
  return (
    <FormInputNumeric<T>
      prefix="$"
      {...props}
      inputClassName={cn(FR_CONTROL_HEIGHT, inputClassName)}
    />
  )
}
